import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M41.7 21.0999H23V2.39993C23 1.79245 22.5075 1.29993 21.9 1.29993C21.2925 1.29993 20.8 1.79245 20.8 2.39993V21.0999H2.1C1.49252 21.0999 1 21.5924 1 22.1999C1 22.8075 1.49252 23.2999 2.1 23.2999H20.8V41.9999C20.8 42.6075 21.2925 43.0999 21.9 43.0999C22.5075 43.0999 23 42.6075 23 41.9999V23.2999H41.7C42.3075 23.2999 42.8 22.8075 42.8 22.1999C42.8 21.5924 42.3075 21.0999 41.7 21.0999Z" fill="black"/>
</svg>
;
